// import { RRule, RRuleSet, rrulestr } from 'rrule'

import { DateTime } from "luxon";
import { IAvailability } from "./Availabilities";

/**
 * Article: https://www.vertabelo.com/blog/again-and-again-managing-recurring-events-in-a-data-model/
 *
 * Use RRULE format: https://www.npmjs.com/package/rrule
 */

export enum RecurrenceType {
  daily = "daily",
  weekly = "weekly",
  monthly = "monthly",
  yearly = "yearly",
}

export interface IRecurringSpecifier {
  timezone: string;
  type: RecurrenceType;
  dayOfWeek?: number[];
  dayOfMonth?: number;
  weekOfMonth?: number;
  monthOfYear?: number;
  separationCount: number;
  text?: string;
}

export interface IRecurringAvailability extends IAvailability {
  name: string;
  isRecurring: true;

  sessionDuration: number; // seconds

  recurrence: IRecurringSpecifier;
  exceptions: {
    startDate: Date | DateTime;
    finishDate: Date | DateTime;
  }[];
}

export namespace RecurrenceType {
  // export function toRRuleFreq(recurrenceType: RecurrenceType) {
  //     switch (recurrenceType) {
  //         case RecurrenceType.daily: return RRule.WEEKLY
  //         case RecurrenceType.weekly: return RRule.WEEKLY
  //         case RecurrenceType.monthly: return RRule.MONTHLY
  //         case RecurrenceType.yearly: return RRule.YEARLY
  //     }
  // }

  export function allOrdered(): RecurrenceType[] {
    return [
      RecurrenceType.daily,
      RecurrenceType.weekly,
      RecurrenceType.monthly,
      // RecurrenceType.yearly,
    ];
  }

  export function toString(recurrenceType: RecurrenceType) {
    switch (recurrenceType) {
      case RecurrenceType.daily:
        return "Day";
      case RecurrenceType.weekly:
        return "Week";
      case RecurrenceType.monthly:
        return "Month";
      case RecurrenceType.yearly:
        return "Year";
    }

    return recurrenceType;
  }

  export function days(): string[] {
    return [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
  }

  export function dayOfTheWeek(): { value: number; name: string }[] {
    return RecurrenceType.days().map((val, idx) => ({ value: idx, name: val }));
  }
}

export namespace IRecurringAvailability {
  // export function toRRuleSet(recurAvail: IRecurringAvailability): RRuleSet {
  //     const ruleSet = new RRuleSet()
  //     ruleSet.rrule(new RRule({
  //         freq: RecurrenceType.toRRuleFreq(recurAvail.recurrence.type),
  //         interval: recurAvail.recurrence.separationCount,
  //         byweekday: recurAvail.recurrence.dayOfWeek,
  //         dtstart: toDateTime(recurAvail.start).toUTC().toJSDate(),
  //         until: toDateTimeNullable(recurAvail.finish)?.toUTC()?.toJSDate()
  //     }))
  //     if (recurAvail.exceptions) {
  //         for (const except of recurAvail.exceptions) {
  //             ruleSet.exrule(new RRule({
  //                 dtstart: toDateTime(except.startDate).toUTC().toJSDate(),
  //                 until: toDateTime(except.finishDate).toUTC().toJSDate()
  //             }))
  //         }
  //     }
  //     return ruleSet
  // }
  // export function calculateAvailabilities(recurring: IRecurringAvailability, start: DateTime, finish: DateTime): IAvailability[] {
  //     // calculate normal duration between start and finish
  //     return IRecurringAvailability.toRRuleSet(recurring)
  //         .between(start.toUTC().toJSDate(), finish.toUTC().toJSDate())
  //         .map(date => ({
  //             ...recurring,
  //             start: date,
  //             finish: toDateTime(date).plus({ seconds: recurring.sessionDuration }).toJSDate()
  //         } as IAvailability)
  //         )
  // }
}
